export const version = '1.9.0';
//# sourceMappingURL=version.js.map